import React from "react";

import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Page } from "../../components/page";
import { ApiStateWidget, ConversionsWidget, FilteredAirlinesWidget } from "../../components/widgets";
import { VIEW_AIRLINES_PRODUCTIVITY_PAGE_PERM, VIEW_CONVERSIONS_PAGE_PERM } from "../../permissions";
import { RootState } from "../../store/root_reducer";

import styles from "./styles.module.scss";

export const DashboardPage: React.FC = () => {
  const { t } = useTranslation("dashboard_page");
  const permissions = useSelector((state: RootState) => state.User.permissions);

  const hasConversions = permissions.includes(VIEW_CONVERSIONS_PAGE_PERM);
  const hasFiltration = permissions.includes(VIEW_AIRLINES_PRODUCTIVITY_PAGE_PERM);

  return (
    <Page withoutCard title={t("page.title")} description={t("page.description")} containerClassName={styles.container}>
      {hasFiltration && <FilteredAirlinesWidget className={styles.filteredAirlines} chunkSize={4} />}
      {hasConversions && (
        <ConversionsWidget className={cn([styles.conversionsWidget, { [styles.hasFiltration]: hasFiltration }])} />
      )}
      {hasConversions && (
        <ApiStateWidget className={cn([styles.apiStateWidget, { [styles.hasFiltration]: hasFiltration }])} />
      )}
    </Page>
  );
};
